/**
 * @file JobSearchEmptySlot.tsx
 *
 * @fileoverview Renders job detail instructions if none job is selected.
 */

import React from 'react';
import Image from '~/jobiqo/components/Image';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import AlignedCenter from '~/vcl/atoms/06-layout/01-alignment/01-align-center';
import RichFormattedMessage from '~/jobiqo/components/RichFormattedMessage';

interface JobSearchEmptySlotProps {
  /**
   * The count of jobs.
   */
  totalCount?: Slottable<number>;
}

export const JobSearchEmptySlot = ({}: JobSearchEmptySlotProps) => {
  return (
    <div
      style={{
        maxWidth: '60%',
        margin: 'auto',
      }}
    >
      <AlignedCenter>
        <Spacing />
        <div>
          <Image
            alt={'Your results'}
            src={'/static/images/job-search-empty.svg'}
            width={400}
            height={400}
          />
        </div>
        <Spacing />
        <div>
          <RichFormattedMessage
            id="job_detail_panel_instructions"
            defaultMessage="To see all the details of a job posting please choose one from the list on the left."
          />
        </div>
      </AlignedCenter>
    </div>
  );
};
export default JobSearchEmptySlot;
